export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <span className="grid place-items-center w-9 h-9 bg-[#FF3B30] -skew-x-12">
      <span className="skew-x-12 font-display font-black text-white text-lg leading-none">ABS</span>
    </span>
    <span className="hidden sm:flex flex-col leading-none">
      <span className="font-display font-extrabold uppercase tracking-wide text-white text-base">Awesome Body</span>
      <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">Sculpting</span>
    </span>
  </span>
);
